import PropTypes from 'prop-types'
import React from 'react'
import { AsYouType } from 'libphonenumber-js'
import { PhoneInput } from 'SRC/ui/FormElements'
import { HidePhoneBtn } from '../HidePhoneBtn'
import { connect } from 'react-redux'
import { getFormInitialValues, change } from 'redux-form'

export const Phone = ({ index, isBlocked, visiblePhonesCount, change }) => {
  const getField = () => ({
    id: `phone-${index}`,
    name: `phones[${index}].phone`,
    label: 'Telefon',
    isRequired: true,
    needDial: false,
    isBlocked: isBlocked,
    wrapperClass: isBlocked ? 'form-group--phone' : 'form-group--phone-hideBtn'
  })

  return (
    <React.Fragment>
      <PhoneInput {...getField()} key={`phone-${index}`} />
      {isBlocked ? <HidePhoneBtn disabled={visiblePhonesCount <= 1} index={index} key={`hideBtn-${index}`} /> : null}
    </React.Fragment>
  )
}

Phone.propTypes = {
  index: PropTypes.number.isRequired,
  isBlocked: PropTypes.bool.isRequired,
  visiblePhonesCount: PropTypes.number.isRequired,
  change: PropTypes.func.isRequired
}

Phone.defaultProps = {
  index: 0,
  isBlocked: false
}

const mapStateToProps = (state, ownProps) => {
  const props = {isBlocked: false}
  const initValues = getFormInitialValues('update')(state)
  if (initValues.phones && Array.isArray(initValues.phones)) {
    const searchedPhone = initValues.phones.filter((item, index) => index === ownProps.index)
    if (searchedPhone.length) {
      props.isBlocked = true
    }
  }
  return props
}

export default connect(mapStateToProps, { change })(Phone)
